export default "__VITE_ASSET__c2c0dfee__"